import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=d6a0e01e&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "./Records.vue?vue&type=style&index=0&id=d6a0e01e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a0e01e",
  null
  
)

export default component.exports